import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { IBranchMastDropdown, ICompanyMastDropdown, IUsersDropdown } from "../../../models/IDropdown";
import { Fetch } from "../../../shared/Fetch";
import { JVDate } from "../../../shared/JVDate";
import { JVDropdown } from "../../../shared/JVDropdown";

interface Iprops {
    filter: IEmptyFilter,
    setFilters: (filters: IEmptyFilter) => void,
}

export interface IEmptyFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    user_Name?: number | null,
    company?: number | null,
    branch?: number | null,
    source?: string | null,
    haveReached?: number | null
}

export const EmptyFilter = {
    fromDate: new Date(),
    toDate: new Date(),
    user_Name: null,
    company: null,
    branch: null,
    source: null,
    haveReached: null
}

export const Filter = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [users, setUsers] = useState<Array<IUsersDropdown>>();
    const [sources, setSources] = useState<Array<{ name: string, value: string }>>([]);

    const { control, handleSubmit, reset, watch } = useForm<IEmptyFilter>({
        defaultValues: EmptyFilter,
        shouldFocusError: false
    });

    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/filterBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    };
    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    };
    const loadUsers = async (branch: number | null | undefined, company: number | null | undefined) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersListHistory", "GET", null, `${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setUsers(data);
        }
    };
    const loadSource = async () => {
        const response = await Fetch("lead-capture/sources", "GET", null, null, null);
        if (response) {
            const data: Array<{ name: string, value: string }> = await response.json();
            const emptyData = {
                name: "-- SELECT --",
                value: "",
            };
            data.unshift(emptyData);
            setSources(data);
        }
    };

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company") {
                if (value.company != 0 && value.company != null) {
                    loadBranches(value.company);
                    loadUsers(0, value.company);
                } else {
                    if (value.company === 0 && value.company != null) {
                        loadBranches();
                        loadUsers(control._formValues.branch, value.company);
                    }
                }
            }

            if (name === "branch") {
                if (value.branch != 0 && value.branch != null) {
                    loadUsers(value.branch, 0);
                } else {
                    if (value.branch === 0 && value.branch != null) {
                        loadUsers(value.branch, control._formValues.company);
                    }
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        loadBranches();
        loadCompanies();
        loadUsers(0, 0);
    }, []);

    const completeMethodBenchConsultant = (event: { query: string }) => {
        console.log(event.query);
    }

    useEffect(() => {
        loadCompanies();
        loadBranches();
        loadSource();
    }, []);

    const searchToDB = async (body: IEmptyFilter) => {
        console.log(body);
        props.setFilters(body);
    }

    const onSubmit = (data: IEmptyFilter) => {
        searchToDB(data);
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
                <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
                <JVDropdown column={6} label="Source" control={control} name="source" options={sources} optionLabel="name" optionValue="value" placeholder="Select Source" />
                <JVDropdown column={6} label="Have Reached" control={control} name="haveReached" options={[{ name: "--Select--", value: null }, { name: "Yes", value: 1 }, { name: "No", value: 2 }]} optionLabel="name" optionValue="value" placeholder="Select" />
                {/* <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" /> */}
                {/* <JVDropdown column={6} label="Branch" control={control} name="branch" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" /> */}
                {/* <JVDropdown column={6} label="Users" control={control} name="user_Name" options={users} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" /> */}

                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6  h-2rem" label="SEARCH" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLEAR" onClick={() => { reset(EmptyFilter) }} type="button"></Button>
                </div>
            </form>
        </>
    );
}